import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChequeredChessWrapper from '../SubscriptionDetails/Components/ChequeredChessWrapper';
import { useAppSelector } from '../../../../state/state';
import { selectActiveRole } from '../../../../state/UserStatesV2/userSliceV2';

const ChequeredPage: React.FC = () => {
    const { subscriptionId } = useParams<{ subscriptionId: string }>();
    const navigate = useNavigate();
    const activeRole = useAppSelector(selectActiveRole);

    if (!subscriptionId) {
        return (
            <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">No Subscription Selected</h2>
                    <button
                        onClick={() => navigate('/mysubscriptions')}
                        className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                    >
                        Go to Subscriptions
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-white shadow-sm border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={() => navigate(`/mysubscriptions/subscription/${subscriptionId}`)}
                                className="text-gray-600 hover:text-gray-900 transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                                </svg>
                            </button>
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                                    ♟️ Chequered - Interactive Chess
                                </h1>
                                <p className="text-sm text-gray-600">
                                    Collaborative chess puzzles and analysis
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => window.open(`/chequered/${subscriptionId}`, '_blank')}
                            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm font-medium transition-colors"
                        >
                            🔗 Open in New Window
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-4 py-6">
                <ChequeredChessWrapper
                    subscriptionId={subscriptionId}
                    subscriptionName="Chess Practice" // Can be fetched from subscription data
                    userRole={activeRole?.role}
                    participantName={activeRole?.displayName || 'Player'}
                />
            </div>
        </div>
    );
};

export default ChequeredPage;

